export default "__VITE_ASSET__DDQ258vl__"